<template>
  <div class="modal fade" id="pagoModal" aria-hidden="true" ref="modalElement">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" :class="form.estatus === 'anulado' ? 'bg-danger' : 'bg-navy'">
          <h4 class="modal-title">
            <i class="fas fa-money-bill-wave mr-2"></i>
            {{ isNew ? 'Registrar Nuevo Pago' : 'Detalles del Pago #' + form.id }}
            <span v-if="form.estatus === 'anulado'" class="badge badge-light ml-2">ANULADO</span>
          </h4>
          <button type="button" class="close text-white" data-dismiss="modal" @click="cerrar">&times;</button>
        </div>

        <form @submit.prevent="guardar">
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-md-12 mb-3">
                <label>Cliente</label>
                <select class="form-control select2" id="clienteSelect" v-model="form.cliente_id" :disabled="!isNew"
                  required style="width: 100%;">
                  <option value="">Seleccione un cliente...</option>
                  <option v-for="c in clientesActivos" :key="c.id" :value="c.id">{{ c.nombre }} ({{ c.rif }})</option>
                </select>
              </div>
              <div class="col-md-6">
                <label>Fecha</label>
                <input type="date" class="form-control" v-model="form.fecha" :disabled="!isNew" required />
              </div>
              <div class="col-md-6">
                <label>Método de Pago</label>
                <select class="form-control" v-model="form.metodo" :disabled="!isNew" required>
                  <option value="Pago Movil">Pago Móvil</option>
                  <option value="Transferencia">Transferencia</option>
                  <option value="Punto">Punto de Venta</option>
                  <option value="Efectivo">Efectivo BsD</option>
                  <option value="Divisa">Divisa</option>
                </select>
              </div>
            </div>

            <div class="row border-top border-bottom py-3 mb-3 bg-light">
              <div class="col-md-4" v-if="form.metodo !== 'Divisa'">
                <label>Tasa BCV</label>
                <input type="text" class="form-control" :value="form.tasa_bcv" :disabled="!isNew"
                  @input="formatPrice($event, 'tasa_bcv')" @keypress="onlyNumbers" required />
              </div>
              <div class="col-md-4" v-if="form.metodo !== 'Divisa'">
                <label>Monto (Bs)</label>
                <input type="text" class="form-control" :value="form.monto_bsd" :disabled="!isNew"
                  @input="formatPrice($event, 'monto_bsd')" @keypress="onlyNumbers" />
              </div>
              <div class="col-md-4">
                <label>Monto ($)</label>
                <input type="text" class="form-control font-weight-bold text-success" :value="form.monto"
                  :disabled="!isNew" @input="formatPrice($event, 'monto')" @keypress="onlyNumbers" required />
              </div>
            </div>

            <div v-if="requiereReferencia" class="card card-outline card-secondary p-3 mb-3">
              <div class="row">
                <div class="col-md-4">
                  <label>Referencia / Aprobación</label>
                  <input type="text" class="form-control" v-model="form.ref" :disabled="!isNew" />
                </div>
                <div class="col-md-4">
                  <label>Banco Origen</label>
                  <select class="form-control" v-model="form.banco_origen" :disabled="!isNew"
                    :required="requiereReferencia">
                    <option value="">Seleccione banco...</option>
                    <option value="0102 - Banco de Venezuela">0102 - Banco de Venezuela</option>
                    <option value="0105 - Mercantil">0105 - Mercantil</option>
                    <option value="0108 - Provincial">0108 - Provincial</option>
                    <option value="0114 - Bancaribe">0114 - Bancaribe</option>
                    <option value="0115 - Exterior">0115 - Exterior</option>
                    <option value="0128 - Banco Caroní">0128 - Banco Caroní</option>
                    <option value="0134 - Banesco">0134 - Banesco</option>
                    <option value="0137 - Sofitasa">0137 - Sofitasa</option>
                    <option value="0138 - Banco Plaza">0138 - Banco Plaza</option>
                    <option value="0151 - BFC">0151 - BFC</option>
                    <option value="0156 - 100% Banco">0156 - 100% Banco</option>
                    <option value="0157 - DelSur">0157 - DelSur</option>
                    <option value="0163 - Tesoro">0163 - Tesoro</option>
                    <option value="0166 - Agrícola">0166 - Agrícola</option>
                    <option value="0168 - Bancrecer">0168 - Bancrecer</option>
                    <option value="0169 - Mi Banco">0169 - Mi Banco</option>
                    <option value="0171 - Activo">0171 - Activo</option>
                    <option value="0172 - Bancamiga">0172 - Bancamiga</option>
                    <option value="0174 - Banplus">0174 - Banplus</option>
                    <option value="0175 - Bicentenario">0175 - Bicentenario</option>
                    <option value="0177 - BANFANB">0177 - BANFANB</option>
                    <option value="0191 - BNC">0191 - BNC</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label>Cuenta Destino</label>
                  <select class="form-control" v-model="form.cuenta_destino" :disabled="!isNew"
                    :required="requiereReferencia">
                    <option value="">Seleccione cuenta...</option>
                    <option value="Banesco - Personal">Banesco - Personal</option>
                    <option value="Banesco - Juridico">Banesco - Juridico</option>
                    <option value="Venezuela - Personal">Venezuela - Personal</option>
                    <option value="Venezuela - Juridico">Venezuela - Juridico</option>
                    <option value="Bancaribe - Personal">Bancaribe - Personal</option>
                    <option value="Bancaribe - Juridico">Bancaribe - Juridico</option>
                  </select>
                </div>
              </div>
              <div class="row mt-2" v-if="form.metodo === 'Pago Movil'">
                <div class="col-md-6">
                  <label>Cédula Origen</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <select class="form-control" v-model="cedula_prefijo" :disabled="!isNew"
                        style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                        <option value="V">V</option>
                        <option value="J">J</option>
                        <option value="E">E</option>
                        <option value="G">G</option>
                      </select>
                    </div>
                    <input type="text" class="form-control" v-model="cedula_numero" :disabled="!isNew"
                      placeholder="12345678" @keypress="onlyNumbers" maxlength="9" minlength="7"
                      :required="form.metodo === 'Pago Movil'" />
                  </div>
                </div>
                <div class="col-md-6">
                  <label>Teléfono Origen</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <select class="form-control" v-model="tlf_prefijo" :disabled="!isNew"
                        style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                        <option value="0412">0412</option>
                        <option value="0422">0422</option>
                        <option value="0416">0416</option>
                        <option value="0426">0426</option>
                        <option value="0414">0414</option>
                        <option value="0424">0424</option>
                      </select>
                    </div>
                    <input type="text" class="form-control" v-model="tlf_numero" :disabled="!isNew"
                      placeholder="1234567" @keypress="onlyNumbers" maxlength="7" minlength="7"
                      :required="form.metodo === 'Pago Movil'" />
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4 border-top pt-3">
              <h6 class="font-weight-bold text-navy"><i class="fas fa-paperclip mr-1"></i> Evidencia del Pago</h6>

              <div v-if="isNew" class="custom-file">
                <input type="file" class="custom-file-input" id="fileComprobante" @change="handleFileUpload"
                  accept="image/*">
                <label class="custom-file-label" for="fileComprobante">
                  {{ fileName || 'Seleccionar captura o foto...' }}
                </label>
              </div>

              <div v-if="!isNew && comprobanteUrl" class="text-center mt-2 bg-light p-2 rounded">
                <a :href="comprobanteUrl" target="_blank">
                  <img :src="comprobanteUrl" class="img-fluid rounded shadow-sm" style="max-height: 200px;"
                    alt="Comprobante">
                  <p class="mb-0 mt-1 small text-primary">Clic para ampliar comprobante</p>
                </a>
              </div>
              <div v-else-if="!isNew" class="text-muted small">No se adjuntó comprobante digital.</div>
            </div>

            <div v-if="form.estatus === 'anulado'" class="alert alert-danger mt-3">
              <strong>Motivo de Anulación:</strong> {{ form.motivo_anulacion }}
              <br><small>Anulado el: {{ form.fecha_anulacion }}</small>
            </div>
          </div>

          <div class="modal-footer justify-content-between bg-light">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Cerrar</button>

            <div class="d-flex">
              <button v-if="!isNew && form.estatus !== 'anulado'" type="button" class="btn btn-danger shadow-sm mr-2"
                @click="solicitarAnulacion">
                <i class="fas fa-ban mr-1"></i> Anular Pago
              </button>

              <button v-if="isNew" type="submit" class="btn btn-success px-4 shadow">
                <i class="fas fa-save mr-1"></i> Registrar Pago
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { alert } from "@/plugins/alert";
import { loading } from "@/plugins/loading";

export default {
  name: "PagoModal",
  props: ["pago", "venta"],
  data() {
    return {
      form: this.initForm(),
      file: null,
      fileName: "",
      clientes: [],
      cedula_prefijo: "V",
      cedula_numero: "",
      tlf_prefijo: "0414",
      tlf_numero: ""
    };
  },
  computed: {
    isNew() { return !this.form.id; },
    requiereReferencia() {
      const m = this.form.metodo.toLowerCase();
      return ['pago movil', 'transferencia'].includes(m);
    },
    clientesActivos() {
      return this.clientes.filter(c => c.estatus != 0);
    },
    comprobanteUrl() {
      // Accedemos a la relación polimórfica que devuelve tu controlador (load('documentos')) 
      // Usamos nombre_sistema que contiene la ruta relativa al disco public
      if (this.form && this.form.id && this.pago.documentos && this.pago.documentos.length > 0) {
        return `${api.defaults.baseURL.replace('/api', '')}/storage/${this.pago.documentos[0].nombre_sistema}`;
      }
      return null;
    }
  },
  methods: {
    initForm(data = {}) {
      return {
        id: data.id || null,
        cliente_id: data.cliente_id || "",
        monto: parseFloat(data.monto || 0).toFixed(2),
        tasa_bcv: parseFloat(data.tasa_bcv || 0).toFixed(2),
        monto_bsd: parseFloat(data.monto_bsd || (data.monto * data.tasa_bcv) || 0).toFixed(2),
        metodo: data.metodo || "Efectivo $",
        fecha: data.fecha || new Date().toISOString().substr(0, 10),
        ref: data.ref || "",
        banco_origen: data.banco_origen || "",
        cuenta_destino: data.cuenta_destino || "",
        cedula_origen: data.cedula_origen || "",
        tlf_origen: data.tlf_origen || "",
        estatus: data.estatus || 'activo',
        motivo_anulacion: data.motivo_anulacion || "",
        fecha_anulacion: data.fecha_anulacion || ""
      };
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.fileName = this.file ? this.file.name : "";
    },
    onlyNumbers(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    formatPrice(e, field) {
      let rawValue = e.target.value.replace(/\D/g, "");
      this.form[field] = (parseInt(rawValue || 0) / 100).toFixed(2);

      // Lógica de reciprocidad de montos
      if (field === 'monto' || field === 'tasa_bcv') {
        this.recalcularBsd();
      } else if (field === 'monto_bsd') {
        this.recalcularDolar();
      }
    },
    recalcularBsd() {
      const monto = parseFloat(this.form.monto || 0);
      const tasa = parseFloat(this.form.tasa_bcv || 0);
      this.form.monto_bsd = (monto * tasa).toFixed(2);
    },
    recalcularDolar() {
      const bsd = parseFloat(this.form.monto_bsd || 0);
      const tasa = parseFloat(this.form.tasa_bcv || 0);
      if (tasa > 0) {
        this.form.monto = (bsd / tasa).toFixed(2);
      }
    },
    initSelect2() {
      this.$nextTick(() => {
        const $select = window.$("#clienteSelect");
        $select.select2({
          theme: 'bootstrap4',
          placeholder: 'Buscar cliente...',
          dropdownParent: window.$("#pagoModal")
        });
        $select.on('change', (e) => {
          this.form.cliente_id = e.target.value;
        });
        // Sincronizar si el valor cambia externamente
        $select.val(this.form.cliente_id).trigger('change');
      });
    },
    async obtenerClientes() {
      try {
        const resp = await api.get("/clientes");
        this.clientes = resp.data;
        this.initSelect2();
      } catch (e) {
        console.error("Error al cargar clientes:", e);
      }
    },
    async guardar() {
      try {
        loading.show('Procesando pago...');

        // Uso de FormData para admitir el archivo comprobante
        const formData = new FormData();
        this.form.cedula_origen = this.cedula_prefijo + this.cedula_numero;
        this.form.tlf_origen = this.tlf_prefijo + this.tlf_numero;
        Object.keys(this.form).forEach(key => formData.append(key, this.form[key]));
        if (this.file) formData.append('comprobante', this.file);

        const resp = await api.post('/pagos', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        loading.hide();
        alert.toast({ title: '¡Pago registrado!', icon: 'success' });
        this.$emit("guardar", resp.data);
        window.$("#pagoModal").modal("hide");
      } catch (error) {
        loading.hide();
        alert.toast({ title: 'Error al cobrar', text: error.response?.data?.message, icon: 'error' });
      }
    },
    async solicitarAnulacion() {
      const { isConfirmed, value: motivo } = await alert.show({
        title: '¿Anular este pago?',
        text: 'Esta acción revertirá los saldos del cliente y las ventas asociadas.',
        input: 'textarea',
        inputPlaceholder: 'Escriba el motivo de la anulación (mínimo 10 caracteres)...',
        showCancelButton: true,
        confirmButtonText: 'Confirmar Anulación',
        confirmButtonColor: '#d33',
        inputValidator: (value) => {
          if (!value || value.length < 10) return 'Debe ingresar un motivo válido y detallado.';
        }
      });

      if (isConfirmed) {
        try {
          loading.show('Ejecutando anulación transaccional...');
          await api.post(`/pagos/${this.form.id}/anular`, { motivo_anulacion: motivo });

          loading.hide();
          alert.toast({ title: 'Pago anulado correctamente', icon: 'success' });
          this.$emit("actualizar");
          window.$("#pagoModal").modal("hide");
        } catch (error) {
          loading.hide();
          alert.toast({ title: 'Error al anular', text: error.response?.data?.message, icon: 'error' });
        }
      }
    },
    cerrar() { this.$emit("cerrar"); }
  },
  mounted() {
    this.obtenerClientes();
  },
  watch: {
    pago: {
      immediate: true,
      handler(val) {
        this.form = this.initForm(val);
        if (this.form.cedula_origen) {
          this.cedula_prefijo = this.form.cedula_origen.charAt(0);
          this.cedula_numero = this.form.cedula_origen.substring(1);
        } else {
          this.cedula_prefijo = "V";
          this.cedula_numero = "";
        }

        if (this.form.tlf_origen && this.form.tlf_origen.length === 11) {
          this.tlf_prefijo = this.form.tlf_origen.substring(0, 4);
          this.tlf_numero = this.form.tlf_origen.substring(4);
        } else {
          this.tlf_prefijo = "0414";
          this.tlf_numero = "";
        }

        this.file = null;
        this.fileName = "";
        if (this.clientes.length > 0) {
          this.$nextTick(() => window.$("#clienteSelect").val(this.form.cliente_id).trigger('change'));
        }
      }
    }
  }
};
</script>